/**
 * Programs Layout Route
 * Parent route that renders child routes (index, detail)
 */

import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/programs")({
  component: ProgramsLayout,
})

function ProgramsLayout() {
  return <Outlet />
}
